import type { InventorySearchQueryInput } from '@openx/types/gqlTypes';
import type { DealPromptSearchFetchArgs } from './context/type';

/**
 * Prefers NLP-derived sub-queries over the raw prompt. An empty `queries` array is a valid NLP
 * result and must not fall back to the prompt — only a missing `queries` does.
 */
export const buildSearchQueryInput = ({ query, queries }: DealPromptSearchFetchArgs): InventorySearchQueryInput[] => {
  if (queries !== undefined) {
    return queries.map(subQuery => ({ query: subQuery }));
  }

  return query ? [{ query }] : [];
};
